.spinner {
  display: inline-block;
  border-radius: 50%;
  border-style: solid;
  border-color: var(--border-default);
  border-top-color: var(--accent);
  animation: ela-spin 0.7s linear infinite;
}

.sm {
  width: 16px;
  height: 16px;
  border-width: 2px;
}

.md {
  width: 24px;
  height: 24px;
  border-width: 2.5px;
}

.lg {
  width: 36px;
  height: 36px;
  border-width: 3px;
}

.centered {
  display: grid;
  place-items: center;
  gap: var(--space-3);
  padding: var(--space-12) var(--space-4);
  color: var(--text-tertiary);
  font-size: var(--text-sm);
}
